module.exports = __webpack_public_path__ + "static/about-right-1-940197da6393b9092db742ae65f3c70d.jpg";